import React, { Component } from "react";
import Calendar from "../../assets/add-decision-calendar.svg";
import { Image } from "react-bootstrap";
import Venue from "../../assets/venue.svg";
import Meeting from "../../assets/meeting.svg";
import ChairedBy from "../../assets/created-by.svg";
import { RedirectUser } from "../reusableComponent";
import { getProjectDecisionDetailsAction } from "../../actions/projectDetail.action";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import PermissionHOC from "../PermissionHOC";
import connect from "react-redux/es/connect/connect";
import { dateFormat } from "../../helper";
import AttachmentIcon from "../../assets/attachment-icon.svg";
import { ReadMore } from "../reusableComponent";
import { MEETING_OPTION } from "../../constant";
import {
  getDayOfTheGivenDate,
  getTimeOfTheGivenDate,
  dateFormatWithCommas,
  textFormattingChange,
  removeUnderscoreFromText
} from "../../helper";
export class AddedDecisionList extends Component {
  render() {
    const { projectAddedDecisionData } = this.props;
    return (
      <div className="add-decision-list">
        <h2 className="add-decision-heading">
          Decision(s) ({projectAddedDecisionData.data.length})
        </h2>
        <div className="decision-details">
          {projectAddedDecisionData.data.map((item, index) => (
            <div className="add-decision-list-section">
              <div className="select-issue-wrapper">
                <div className="add-decision-headers agenda-decision">
                  {item.meetingId !== null ? (
                    <div className="agenda_id_col">
                      AGENDA ID{" "}
                      <span className="agenda-id">#{item.meetingId}</span>{" "}
                    </div>
                  ) : null}

                  <div class="agenda-detail-info decision-agenda-detail">
                    <span className="add-decision-images">
                      <Image src={Calendar} alt="Plus Icon" />
                    </span>
                    <span>
                      <b>When</b>
                      {getDayOfTheGivenDate(item.meetingDate)}
                      {", "}
                      {dateFormatWithCommas(item.meetingDate)}{" "}
                      {getTimeOfTheGivenDate(item.meetingTimeFrom)}
                    </span>
                  </div>
                  <div class="agenda-detail-info decision-agenda-detail">
                    <span className="add-decision-images">
                      <Image src={Venue} alt="Plus Icon" />
                    </span>
                    <span>
                      <b>Venue</b>
                      {item.venueName}
                    </span>
                  </div>
                  <div class="agenda-detail-info decision-agenda-detail">
                    <span className="add-decision-images">
                      <Image src={Meeting} alt="Plus Icon" />
                    </span>
                    <span>
                      <b>Meeting Type</b>
                      {removeUnderscoreFromText(item.projectMeetingType)}
                    </span>
                  </div>
                  <div class="agenda-detail-info decision-agenda-detail chaired-by">
                    <span className="add-decision-images">
                      <Image src={ChairedBy} alt="Plus Icon" />
                    </span>
                    <span>
                      <b>Chaired By</b>
                      {item.meetingChairedBy}
                    </span>
                  </div>
                </div>
                <div className="select-issue-content add-decision-issues">
                  <div
                    className={`mom-desc ${
                      item.projectmom.length < 300 ? "mom-desc-height" : ""
                    }`}
                  >
                    <div>
                      <h4>{item.decisionName}</h4>
                      <p className="project-mom-details">
                        {item.projectmom.length > 670 ? (
                          <ReadMore
                            content={item.projectmom}
                            displayExpandButtons={true}
                            clamp={5}
                            isProjectMom={true}
                          />
                        ) : (
                          <>{item.projectmom}</>
                        )}
                      </p>
                      {item.fileDTOList.length !== 0 && (
                        <div className="add-attachment-button">
                          <Image
                            src={AttachmentIcon}
                            alt="Attachment Icon"
                            className="add-attachment-img"
                          />
                          <span className="add-attachment-text">
                            {item.fileDTOList.map((file, idx) => (
                              <a
                                className="ml-0"
                                href={file.s3Url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {idx < item.fileDTOList.length - 1
                                  ? file.name + ", "
                                  : file.name + ""}
                              </a>
                            ))}
                          </span>
                        </div>
                      )}
                    </div>
                    {item.projectmom.length > 300 && (
                      <div
                        className={`${
                          item.fileDTOList.length !== 0
                            ? "mom-bottom-details-content"
                            : "mom-details-bottom-info"
                        } d-flex justify-content-between`}
                      >
                        <div>
                          <span className="meeting-mode">
                            <b>Meeting Mode: </b>{" "}
                            {MEETING_OPTION[item.meetingMode]}
                          </span>
                        </div>
                        <div>
                          <div className="project-created-date d-flex">
                            <div className="project-created-by verified-user">
                              <p />
                            </div>
                            <RedirectUser
                              title={item.decisionCreatedByName}
                              id={item.decisionCreatedById}
                              isProjectProponentDetail={true}
                            />
                            <div className="project-created-on">
                              | Decision Submitted on:{" "}
                              {dateFormat(item.createdDate)}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {item.projectmom.length < 300 && (
                    <div className="d-flex justify-content-between mom-bottom-details">
                      <div>
                        <span className="meeting-mode">
                          <b>Meeting Mode: </b>{" "}
                          {MEETING_OPTION[item.meetingMode]}
                        </span>
                      </div>
                      <div>
                        <div className="project-created-date d-flex">
                          <div className="project-created-by verified-user">
                            <p />
                          </div>
                          <RedirectUser
                            title={item.decisionCreatedByName}
                            id={item.decisionCreatedById}
                            isProjectProponentDetail={true}
                          />
                          <div className="project-created-on">
                            | Decision Submitted on:{" "}
                            {dateFormat(item.createdDate)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProjectDecisionDetailsAction
    },
    dispatch
  );
}
export default withRouter(
  PermissionHOC(
    connect(
      null,
      mapDispatchToProps
    )(AddedDecisionList)
  )
);
